// src/pages/Favorites.js
// Page des favoris - affiche les vraies annonces uniquement - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import { useListings } from '../hooks/useListings';
import apiClient from '../api/client';

const Favorites = () => {
  const { t } = useTranslation();
  const { getFavorites } = useListings();
  const [favoriteListings, setFavoriteListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFavorites = async () => {
      setLoading(true);
      const favoriteIds = getFavorites();

      if (favoriteIds.length === 0) {
        setFavoriteListings([]);
        setLoading(false);
        return;
      }

      try {
        // Récupère chaque annonce favorite par son ID, en ignorant celles qui n'existent plus
        const results = await Promise.allSettled(
          favoriteIds.map((id) => apiClient.get(`/endpoints/listings.php?action=detail&id=${id}`))
        );
        const valid = results
          .filter((r) => r.status === 'fulfilled')
          .map((r) => r.value);
        setFavoriteListings(valid);
      } catch (err) {
        setFavoriteListings([]);
      } finally {
        setLoading(false);
      }
    };

    loadFavorites();
  }, [getFavorites]);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    title: { fontSize: '22px', fontWeight: '700', color: '#FFFFFF' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: '#A0AEC0' },
    emptyContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px 24px',
      textAlign: 'center',
      gap: '12px',
    },
    emptyIcon: { fontSize: '56px', opacity: 0.4 },
    emptyTitle: { fontSize: '16px', fontWeight: '600', color: '#FFFFFF' },
    emptyText: { fontSize: '14px', color: '#A0AEC0', maxWidth: '280px', lineHeight: '1.5' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Mes favoris | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <div style={styles.title}>❤️ {t('nav.favorites')}</div>
      </div>

      {!loading && favoriteListings.length > 0 && (
        <div style={styles.subtitle}>
          {favoriteListings.length} annonce{favoriteListings.length > 1 ? 's' : ''} sauvegardée{favoriteListings.length > 1 ? 's' : ''}
        </div>
      )}

      {!loading && favoriteListings.length === 0 ? (
        <div style={styles.emptyContainer}>
          <div style={styles.emptyIcon}>🤍</div>
          <div style={styles.emptyTitle}>Aucun favori pour l'instant</div>
          <div style={styles.emptyText}>
            Appuyez sur le cœur d'une annonce pour la sauvegarder ici et la retrouver facilement.
          </div>
        </div>
      ) : (
        <ListingGrid listings={favoriteListings} loading={loading} />
      )}
    </div>
  );
};

export default Favorites;